// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/carburetor-heat-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/carburetor-heat-technique/carburetor-heat-technique.js';

mount([g0]);
